import { Box, Card, CardContent, Typography } from '@material-ui/core';
import { constants } from 'helpers/constants';
import React from 'react';

import { SalePageLink } from './SalePageLink';
import styles from './styles';

import type IProduct from 'interfaces/IProduct';

interface IProps {
  physicalProductPending: boolean;
  currentProduct: IProduct;
  currentUserId: number;
  classes?: any;
}

const SalesPageUrls = ({ physicalProductPending, currentProduct, currentUserId, classes }: IProps) => {
  return (
    <Card className={classes.root}>
      <CardContent className={classes.cardContent}>
        <Typography gutterBottom variant='h5' component='h2' className={classes.mainTitle}>
          Crie sua página com Orbit Pages!
        </Typography>
        <Typography className={classes.paragraph} component='p'>
          Clientes Eduzz tem 3 páginas grátis! Clique no botão abaixo para começar.
        </Typography>
        <a className={classes.btnNewPage} href={constants.links.OrbitPage} target='_blank' rel='Reverse Tabnabbing noreferrer'>
          <span>Criar minhas páginas - É grátis!</span>
        </a>

        <CardContent className={classes.cardLink}>
          <Typography className={classes.linksSubtitle} variant='h6'>
            Página de vendas / Padrão Eduzz
          </Typography>
          <Box component='div' className={classes.contentLink}>
            <SalePageLink currentProduct={currentProduct} currentUserId={currentUserId} physicalProductPending={physicalProductPending} />
          </Box>
        </CardContent>
      </CardContent>
    </Card>
  );
};

export default styles(SalesPageUrls) as any;
